import React, { Component } from 'react'
import { Table } from 'reactstrap'
import { AddLicensesRow } from './'

class AddLicenses extends Component {
render() {
    const { possibleLicenses, district, accountId } = this.props
    return (
      <Table>
        <thead>
          <tr>
          <th>Product</th>
          <th>License Type</th>
          <th>License Quantity</th>
          <th>Start Date / End Date</th>
          <th>Add License</th>
          </tr>
        </thead>
        <tbody>
        {possibleLicenses.map(license => 
          <AddLicensesRow 
            key={license.id}
            license={license}
            district={district}
            accountId={accountId}
          />
        )}
        </tbody>
      </Table>
    )
  }
}

export default AddLicenses


// WEBPACK FOOTER //
// ./src/components/Users/Licenses/AddLicenses.js